<template>

    <div class="page-wrapper">

       <!-- Menu Superior de Navegación -->
       <navbar-new></navbar-new>

       <electric-start></electric-start>

       <feature></feature>

        <!-- Acordion -->
       <accordion></accordion>

      <!-- logo y texto -->
      <certification></certification>

       <!-- Pie de Página -->
       <footer-new></footer-new>
        

    </div>
</template>
  
<script>
  import navbarNew from '../components/navbar.vue'

  import electricStart from '../components/electric/electricStart.vue'

  import feature from '../components/electric/feature.vue'

  import accordion from '../components/electric/accordion.vue'

  import certification from '../components/electric/certification.vue'

  import footerNew from '../components/footer.vue'

  export default {
    components: {
    navbarNew,
    electricStart,
    feature,
    accordion,
    certification,
    footerNew
  }
  }
  
</script>
  